/**
 * Numbers list requests so that an older answer cannot overwrite a newer one that was applied first (DASH section 4 5a).
 * `isLatest(n)` is true unless a response for a later request has already been applied; asking marks `n` as applied.
 */
export const createSequencer = () => {
    let issued = 0;
    let applied = 0;
    return {
        next: () => {
            issued += 1;
            return issued;
        },
        isLatest: (n) => {
            if (n < applied) return false;
            applied = n;
            return true;
        },
    };
};

/**
 * The list with a write's answer in it: the project with the same id is replaced, an unknown one is appended.
 * @returns {object[]} a new list
 */
export const applyWriteResponse = (projects, projectData) => {
    let known = false;
    const next = projects.map((project) => {
        if (project.id !== projectData.id) return project;
        known = true;
        return projectData;
    });
    return known ? next : [...next, projectData];
};
